/**
 * Estado expandido del sidebar de escritorio (compartido NavbarMain / NavbarAdmin).
 * Por defecto colapsado; persiste en localStorage.
 */
import { reactive } from 'vue';

const STORAGE_KEY = 'po_sidebar_expanded';
const W_COLLAPSED = '72px';
const W_EXPANDED = '220px';

function leerInicial() {
    try {
        return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

export const sidebarExpandState = reactive({
    expanded: leerInicial(),
});

function aplicarAnchoCss(expanded) {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    root.style.setProperty('--po-sidebar-w', expanded ? W_EXPANDED : W_COLLAPSED);
    root.classList.toggle('po-sidebar-expanded', !!expanded);
}

export function syncSidebarExpandCss() {
    aplicarAnchoCss(sidebarExpandState.expanded);
}

export function setSidebarExpanded(expanded) {
    sidebarExpandState.expanded = !!expanded;
    try {
        localStorage.setItem(STORAGE_KEY, sidebarExpandState.expanded ? '1' : '0');
    } catch {
        /* ignore */
    }
    aplicarAnchoCss(sidebarExpandState.expanded);
}

export function toggleSidebarExpanded() {
    setSidebarExpanded(!sidebarExpandState.expanded);
}

// Aplica al cargar el módulo (antes del primer paint del panel si el chunk ya está).
if (typeof document !== 'undefined') {
    syncSidebarExpandCss();
}
